
import React from 'react';
import { logger } from '@/utils/production-logger';
import { STABLE_CONFIGS } from '@/constants/ai-assistant-context-constants';

/**
 * Configuration and initialization logic for AiAssistantProvider
 */
export const providerConfig = {
  componentName: 'AiAssistantProvider',
  stableConfigs: STABLE_CONFIGS,
  
  logInitialization: (step: string, metadata?: any) => {
    // Only log initialization in development mode
    if (process.env.NODE_ENV === 'development') {
      logger.debug(`AiAssistantProvider ${step}`, {
        component: 'AiAssistantProvider',
        ...metadata
      });
    }
  },
  
  logError: (error: Error, context?: string) => {
    logger.error(`AiAssistantProvider ${context || 'error'}`, {
      error: error.message,
      stack: error.stack,
      component: 'AiAssistantProvider'
    });
  }
};

/**
 * Fallback UI component for initialization errors
 */
export const ProviderFallbackUI: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <h2 className="text-xl font-semibold mb-2">AI Assistant Unavailable</h2>
      <p className="text-muted-foreground mb-4">
        We're experiencing technical difficulties. Please refresh the page.
      </p>
      <button 
        onClick={() => window.location.reload()} 
        className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
      >
        Refresh Page
      </button>
    </div>
  </div>
);
